import {statusMatches} from 'rfp/bid-manager/main/core/actions/bid-manager-actions-factory-helpers';
import {SvelteDialog} from 'root/v-app/rbServices';
import {logError} from 'root/log/log';

export default function createBidManagerUploadAction(config){
  return function (selectedBidsReport){
    return {
      label: config.labelFn? config.labelFn(selectedBidsReport): config.label,
      icon: config.icon,
      isAvailable: () => statusMatches(selectedBidsReport.statuses, config.validStates),
      action: () => {
        SvelteDialog.show(config.dialog, {
          bids: filterBidsInValidStates(selectedBidsReport, config.validStates),
          actionResultHandler: config.actionResultHandler,
        }).catch(logError);
      }
    }
  }
}

function filterBidsInValidStates(selectedBidsReport, validStates){
  return selectedBidsReport.bids.filter(b => validStates.includes(b.state.status));
}
